<app-dialog-base>
  <span dialog-title>Charity Payout Details</span>

  <ng-container dialog-content>
    <div class="payout-details">
      <div class="detail-row">
        <div class="detail-label">Charity Name</div>
        <div class="detail-value" data-testid="charity-name">{{ data.charityName }}</div>
      </div>

      <div class="detail-row">
        <div class="detail-label">Payout ID</div>
        <div class="detail-value" data-testid="payout-id">{{ data.payout.Id }}</div>
      </div>

      <div class="detail-row">
        <div class="detail-label">Payout Amount</div>
        @if (!isEditingAmount) {
          <div class="detail-value-with-action">
            <div class="detail-value" data-testid="payout-amount">{{ data.payout.PayoutAmount | formatCurrency }}</div>
            @if (canAddNotes) {
              <button
                mat-icon-button
                color="primary"
                (click)="startEditingAmount()"
                matTooltip="Edit payout amount"
                data-testid="edit-amount-button">
                <mat-icon>edit</mat-icon>
              </button>
            }
          </div>
        } @else {
          <div class="edit-amount-section" data-testid="edit-amount-section">
            <mat-form-field appearance="outline" class="amount-field">
              <mat-label>New Payout Amount</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="editedAmount"
                step="0.01"
                min="0.01"
                [disabled]="isSubmittingNote"
                data-testid="edit-amount-input">
              <span matTextPrefix>$&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline" class="note-field">
              <mat-label>Reason for change (required)</mat-label>
              <textarea
                matInput
                [(ngModel)]="editNoteText"
                placeholder="Explain why the amount is being changed..."
                rows="2"
                [disabled]="isSubmittingNote"
                data-testid="edit-note-input"></textarea>
            </mat-form-field>
            <div class="button-row">
              <button
                mat-button
                (click)="cancelEditingAmount()"
                [disabled]="isSubmittingNote"
                data-testid="cancel-edit-button">
                Cancel
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="saveEditedAmount()"
                [disabled]="!editedAmount || editedAmount <= 0 || !editNoteText.trim() || isSubmittingNote"
                data-testid="save-edit-button">
                {{ isSubmittingNote ? 'Saving...' : 'Save Changes' }}
              </button>
            </div>
          </div>
        }
      </div>

      <div class="detail-row">
        <div class="detail-label">Created On</div>
        <div class="detail-value" data-testid="created-on">{{ data.payout.CreatedOnDate | date: 'MMM d, y, h:mm a' }}</div>
      </div>

      <div class="detail-row">
        <div class="detail-label">Last Updated</div>
        <div class="detail-value" data-testid="last-updated">{{ data.payout.LastUpdatedDate | date: 'MMM d, y, h:mm a' }}</div>
      </div>

      <div class="detail-row">
        <div class="detail-label">Created By (Admin ID)</div>
        <div class="detail-value" data-testid="created-by">{{ data.payout.CreatedBy }}</div>
      </div>

      <div class="detail-row">
        <div class="detail-label">Last Updated By (Admin ID)</div>
        <div class="detail-value" data-testid="last-updated-by">{{ data.payout.LastUpdatedBy }}</div>
      </div>

      <mat-divider></mat-divider>

      <div class="notes-section">
        <h3 class="section-title">Notes</h3>

        @if (canAddNotes) {
          <mat-card appearance="outlined" class="add-note-card" data-testid="add-note-section">
            <mat-card-content>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Add a note</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="newNoteText"
                  placeholder="Enter note text..."
                  rows="3"
                  [disabled]="isSubmittingNote"
                  data-testid="add-note-input"></textarea>
              </mat-form-field>
              <div class="button-row">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="addNote()"
                  [disabled]="!newNoteText.trim() || isSubmittingNote"
                  data-testid="add-note-button">
                  {{ isSubmittingNote ? 'Adding...' : 'Add Note' }}
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        }

        @if (isLoadingNotes) {
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="loading-notes" data-testid="loading-notes">Loading notes...</div>
            </mat-card-content>
          </mat-card>
        } @else if (notes.length === 0) {
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="no-notes" data-testid="no-notes">No notes have been added yet</div>
            </mat-card-content>
          </mat-card>
        } @else {
          <div class="notes-list" data-testid="notes-list">
            @for (note of notes; track note.Id) {
              <mat-card appearance="outlined" [attr.data-testid]="'note-' + note.Id">
                <mat-card-content>
                  <p class="note-text">{{ note.Note }}</p>
                  <mat-divider></mat-divider>
                  <div class="note-meta">
                    <span class="note-date">{{ note.CreatedOn | date: 'MMM d, y, h:mm a' }}</span>
                    <span class="note-separator">•</span>
                    <span class="note-author">Admin ID: {{ note.CreatedBy }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            }
          </div>
        }
      </div>
    </div>
  </ng-container>

  <ng-container actions></ng-container>
</app-dialog-base>
